import { css, jsx } from '@emotion/core';

import { bp, colors } from '@/styles';

const style = {
  pageButtons: css`
    background-color: ${colors.white};
  `,
  paginationRow: css`
    display: flex;
  `,
  btnRow: disabled => css`
    display: flex;
    flex-direction: column;
    align-items: initial;
    @media ${bp.md} {
      flex-direction: row;
      justify-content: space-between;
    }
    ${disabled
      ? css`
          .ant-btn:disabled {
            color: rgba(0, 0, 0, 0.25) !important;
            &:hover {
              border-color: #dadad7 !important;
            }
          }
        `
      : null}
  `,
  btnGroup: css`
    @media (max-width: 575px) {
      flex-wrap: wrap;
      margin-top: 6px;
    }
  `,
  expandCollapseBtns: css``,
};

export default style;
